import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
} from "@mui/material";

import MDButton from "components/MDButton";
import { useAlerta } from "utils/alertas";

const ModalEditarCostos= ({open, onClose, usuarioId, onActualizado}) =>{

    const [inscripciones, setInscripciones] = useState([]);
    const [inscripcionSeleccionada, setInscripcionSeleccionada] = useState("");
    const [costos, setCostos] = useState([]);
    const [costoSeleccionado, setCostoSeleccionado] = useState("");
    const { mostrarAlerta } = useAlerta();

    useEffect(() => {
        if (!open || !usuarioId) return;

        const token = sessionStorage.getItem("access_token");

        fetch(`${process.env.REACT_APP_API_URL}/usuarios/${usuarioId}/deudas`, {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
            },
        })
            .then(res => res.json())
            .then(data => {
                setInscripciones(data);
                setInscripcionSeleccionada("");
                setCostoSeleccionado("");
            })
            .catch(console.error);

    }, [open, usuarioId]);
    const guardarCostos = () => {
        const token = sessionStorage.getItem("access_token");

        const payload = {
            items: costos.map((item) => ({
                ids: item.ids,
                costo: Number(item.costo)
            }))
        };

        fetch(`${process.env.REACT_APP_API_URL}/inscripciones/${inscripcionSeleccionada}/costos`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then(res => res.json())
            .then(() => {
                mostrarAlerta("Costo actualizado correctamente", "success");
                onClose();
                if (onActualizado) {
                    onActualizado();
                }
            })
            .catch(console.error);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Editar costos</DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2} sx={{ mt: 0.5 }}>

                    <Grid item xs={12}>
                        <TextField
                            select
                            fullWidth
                            label="Inscripción"
                            value={inscripcionSeleccionada}
                            onChange={(e) => {
                                const id = e.target.value;
                                setInscripcionSeleccionada(id);

                                if (!id) return;

                                const token = sessionStorage.getItem("access_token");

                                fetch(`${process.env.REACT_APP_API_URL}/inscripciones/${id}/costos`, {
                                    headers: {
                                        Authorization: `Bearer ${token}`,
                                        Accept: "application/json",
                                    },
                                })
                                    .then(res => res.json())
                                    .then(data => {
                                        setCostos(data);
                                    })
                                    .catch(console.error);
                            }}
                            SelectProps={{ native: true }}
                            
                        >
                            <option value=""></option>

                            {inscripciones.map((item) => (
                                <option
                                    key={`${item.tipo}-${item.id}`}
                                    value={item.id}
                                >
                                    {item.texto}
                                </option>
                            ))}
                        </TextField>
                    </Grid>

                    {costos.length > 0 && (
                    <>
                        <Grid item xs={12}>
                            <TextField
                                select
                                fullWidth
                                label="Concepto"
                                value={costoSeleccionado}
                                onChange={(e) => setCostoSeleccionado(e.target.value)}
                                SelectProps={{ native: true }}
                            >
                                <option value=""></option>

                                {costos.map((item, index) => (
                                    <option value={index} key={index}>
                                        {item.descripcion}
                                    </option>
                                ))}
                            </TextField>
                        </Grid>

                        {costoSeleccionado !== "" && (
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label={`Costo ${costos[costoSeleccionado].descripcion}`}
                                    type="number"
                                    value={costos[costoSeleccionado].costo}
                                    onChange={(e) => {
                                        const nuevos = [...costos];

                                        nuevos[costoSeleccionado].costo = e.target.value;

                                        setCostos(nuevos);
                                    }}
                                />
                            </Grid>
                        )}
                    </>
                )}

                </Grid>
            </DialogContent>

            <DialogActions>
                <MDButton
                    color="error"
                    onClick={onClose}
                >
                    Cancelar
                </MDButton>

                <MDButton
                    color="info"
                    onClick={guardarCostos}
                >
                    Guardar
                </MDButton>
            </DialogActions>
        </Dialog>
    );
};
export default ModalEditarCostos;